module.exports = __webpack_public_path__ + "img/Html_Icon.6c724ec7.png";